import React, { useState } from 'react';
import { Button } from 'antd';
import { useForm } from 'react-hook-form';
import { signUp } from '../../api/index';

const SignUpForm = (props) => {
    const { register, errors, handleSubmit, setError } = useForm();
    const [loading, setLoading] = useState(false);
    const { changeTab } = props;
    const onSubmit = (data) => {
        setLoading(true);
        signUp(data)
            .then((response) => {
                setLoading(false);
                changeTab({ title: 'Registration Success', body: response.message });
            })
            .catch((error) => {
                const keys = Object.keys(error.errors);
                keys.forEach((key) => {
                    setError(key, 'notMatch', error.errors[key]);
                });
                setError(error.errors);
                setLoading(false);
            });
    };

    // const Loading = <LoadingOutlined sytle={{fontSize: 24}}/>

    return (
        <form test_id="signup-form" className="entry-form" onSubmit={handleSubmit(onSubmit)}>
            <div className="formFieldContainer">
                <label htmlFor="email"> Email</label>
                <input
                    test_id="signup-email"
                    name="email"
                    placeholder="Enter Email"
                    ref={register({
                        required: true,
                        pattern:
                            /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    })}
                />
                {
                    errors.email?.type === 'required' && (
                        <span className="formFieldError"> Please enter your email. </span>
                    )
                    // <Alert type='error' showIcon message="Email requried."/>
                }
                {
                    errors.email?.type === 'pattern' && <span className="formFieldError"> Invalid email address. </span>
                    // <Alert type='error' showIcon message="Invalid email format."/>
                }
                {
                    errors.email?.type === 'notMatch' && (
                        <span className="formFieldError" style={{ fontSize: '0.75em' }}>
                            {' '}
                            {errors.email.message}{' '}
                        </span>
                    )
                    // <Alert type='error' showIcon message={errors.email.message}/>
                }
            </div>

            <div className="formFieldContainer">
                <label htmlFor="password">Password</label>
                <input
                    test_id="signup-password"
                    name="password"
                    type="password"
                    placeholder="Enter Password"
                    ref={register({
                        required: true,
                        minLength: 8,
                        maxLength: 32,
                    })}
                />
                {
                    errors.password?.type === 'required' && (
                        <span className="formFieldError"> Please enter your password. </span>
                    )
                    // <Alert type='error' showIcon message="Password requried."/>
                }
                {
                    errors.password?.type === 'minLength' && (
                        <span className="formFieldError"> Must be at least 8 characters. </span>
                    )
                    // <Alert type='error' showIcon message="Password length must be 8."/>
                }
            </div>

            {/* {
        !loading ? (<input test_id="signup-submit" className="entry-button" type="submit" value="Sign up"/>):(
          <Spin test_id="signup-loading" indicator={Loading}/>
        ) 
      } */}

            <Button test_id="signup-submit" htmlType="submit" loading={loading}>
                Sign up
            </Button>
        </form>
    );
};

export default SignUpForm;
